import React from "react";
import "./goBackButton.scss"; // Import the SCSS file
import { routes } from "../../../__product__/navigation/routes";
import { ArrowBack } from "@mui/icons-material";
import { useMyNavigate } from "../../../__product__/navigation/myNavigate";

const GoBackButton: React.FC = () => {
  const navigate = useMyNavigate();
  return (
    <div
      className="go-categories-button" // Apply the SCSS class name
      onClick={() => {
        navigate(routes.initial);
      }}
    >
      <ArrowBack />
    </div>
  );
};

export default GoBackButton;
